<template>
  <div class="home-center">
    <div class="tops-center">
      <div class="left-box">
        <div class="titles">
          <img class="icon" :src="downLoadUrl1" alt />
          <span>门店数据</span>
        </div>
        <div class="boxs">
          <div
            class="box"
            v-for="(item,index) in list"
            :key="index"
            @click="handleClick(item,index)"
          >
            <img class="icon" :src="item.iconUrl" alt />
            <span class="name">{{ item.name }}</span>
          </div>
        </div>
      </div>
      <div class="right-box">
        <div class="titles">
          <img class="icon" :src="downLoadUrl2" alt />
          <span>门店资源</span>
        </div>
        <div class="boxs">
          <div
            class="box"
            v-for="(item,index) in toDoList"
            :key="index"
            @click="handleClick(item,index)"
          >
            <img class="icon" :src="item.iconUrl" alt />
            <span class="name">{{ item.name }}</span>
          </div>
        </div>
      </div>
      
    </div>
    <div class="tops-center">
      <div class="left-bottom-box left-box">
        <div class="titles">
          <img class="icon" :src="downLoadUrl2" alt />
          <span>应用</span>
        </div>
        <div class="boxs">
          <div
            class="box"
            v-for="(item,index) in applicationList"
            :key="index"
            @click="handleClick(item,index)"
          >
            <img class="icon" :src="item.iconUrl" alt />
            <span class="name">{{ item.name }}</span>
          </div>
        </div>
      </div>
      <!-- <div class="right-box">
        <div class="titles">
          <img class="icon" :src="downLoadUrl2" alt />
          <span>门店资源</span>
        </div>
        <div class="boxs">
          <div
            class="box"
            v-for="(item,index) in toDoList"
            :key="index"
            @click="handleClick(item,index)"
          >
            <img class="icon" :src="item.iconUrl" alt />
            <span class="name">{{ item.name }}</span>
          </div>
        </div>
      </div> -->
    </div>
    <!-- <member-cancel-card ref="memberCancelCardForm"></member-cancel-card> -->
    <!-- <member-top-up ref="memberTopUpForm" @change="rechargeApply"></member-top-up> -->
  </div>
</template>

<script>
// import memberCancelCard from "./member/cancelCard";
// import memberTopUp from "./member/topUp";
import minxin from "../../../assets/javascript/minxin.js";
export default {
  components: {
    // memberCancelCard,
    // memberTopUp
  },
  mixins: [minxin],
  data() {
    return {
      appInfo: this.$store.getters.AppInfo,
      downLoadUrl1: require("../../../assets/images/home/2.png"),
      downLoadUrl2: require("../../../assets/images/home/1.png"),
      toDoList: [],
      list: [],
      rechargeForm: {},
      menuInfo: [],
      applicationList: []
    };
  },
  // mixins: [minxin],

  computed: {},

  created() {
      
  },
  mounted() {},
  destroyed() {
    // this.$store.commit("setSwitchShopInfo", false);
  },
  watch: {
    
  },
  methods: {
    
    handleClick(item) {
      console.log(item)
      if (item.url) {
        this.$router.push(item.url);
      } else {
        if (item.childUrl == "memberRecharge") {
          this.$refs["memberTopUpForm"].$emit("set", item);
        }
        if (item.childUrl == "memberLogout") {
          this.$refs["memberCancelCardForm"].$emit("set", item);
        }
        // this.$refs["memberCancelCardForm"].$emit("set", item);
      }
    }
  }
};
</script>

<style lang="less" scoped>
@radius: 0;
@shadow: none;
@import "../../../assets/css/edit.less";
.home-center {
  .setMoney {
    margin-bottom: 10px;
    background-color: #fff;
    height: 45px;
    display: flex;
    align-items: center;
    p {
      margin-left: 30px;
      font-weight: bold;
    }
    .money {
      color: @money;
    }
  }
  .left-bottom-box {
    width: 563px !important;
  }
  .tops-center {
    margin-bottom: 15px;
    display: flex;
    .left-box,
    .right-box {
      width: 596px;
      margin-right: 15px;
      background-color: #fff;
      box-shadow: @shadow;
      border-radius: @radius;
      padding: 28px 27px;
      overflow: hidden;
      .titles {
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 5px;
        display: flex;
        align-items: center;
        span {
          margin-left: 10px;
        }
      }
      .boxs {
        display: flex;
        flex-wrap: wrap;
        .box {
          width: 156px;
          height: 66px;
          margin: 0 15px;
          margin-top: 25px;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          border-radius: 5px;
          cursor: pointer;
          .icon {
            max-width: 42px;
          }
          .name {
            font-size: 16px;
            font-weight: bold;
            margin-left: 10px;
          }
          &:hover {
            background: rgba(51, 111, 237, 0.2);
          }
        }
      }
    }
    .right-box {
      width: 596px;
      margin: 0;
      background-color: #fff;
      box-shadow: @shadow;
      border-radius: @radius;
      padding: 28px 27px;
      .titles {
        font-size: 18px;
        font-weight: bold;
        display: flex;
        align-items: center;
        span {
          margin-left: 10px;
        }
      }
      .todo {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        // align-items: center;
        // height: calc(100% - 24px);
        .msg {
          // margin-top: 25px;
          // margin-bottom: 25px;
          margin-top: 39px;
          text-align: center;
          .num {
            margin-bottom: 10px;
          }
          .name {
            font-size: 16px;
            font-weight: bold;
          }
        }
        .msg-tops {
          margin-top: 21px;
        }
      }
    }
  }
  .bottoms-center {
    width: 1250px;
    height: 267px;
    box-shadow: @shadow;
    border-radius: @radius;
    background-color: #fff;
    padding: 23px 27px;
    box-sizing: border-box;
    .titles {
      font-size: 18px;
      font-weight: bold;
      display: flex;
      align-items: center;
      span {
        margin-left: 10px;
      }
      .icon {
        font-size: 18px;
        width: 18px;
        height: 18px;
      }
      .times {
        font-size: 14px;
        color: #333;
        font-weight: normal;
      }
    }
    .boxs {
      margin-top: 20px;
    }
    .rows {
      // display: flex;
      // flex-wrap: wrap;
      .cols {
        // width: 220px;
        height: 60px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .name {
          font-size: 16px;
          font-weight: bold;
          margin-top: 5px;
        }
        .icon {
          color: @blue;
        }
      }
    }
  }
}
</style>